// extracted by mini-css-extract-plugin
export var active = "step-indicator-module--active--7df06";
export var indicatorLine = "step-indicator-module--indicator-line--6b620";
export var stepIcon = "step-indicator-module--step-icon--13859";
export var stepIndicator = "step-indicator-module--step-indicator--c753c";
export var stepWrapper = "step-indicator-module--step-wrapper--7ae9e";
export var visuallyHidden = "step-indicator-module--visually-hidden--f1f37";